export default __webpack_public_path__ + "static/media/team-img.de88c667.png";